import {
  Document,
  DocumentStatus,
  Folder,
  FolderChatStatus,
} from "~/api/model";

export const isDocumentSelectable = (
  document: Document,
  allFilesNotProcessed: boolean,
  caseData?: Folder
): boolean => {
  return (
    document.status === DocumentStatus.COMPLETE &&
    !allFilesNotProcessed &&
    caseData?.chatStatus === FolderChatStatus.COMPLETE
  );
};

export const getSelectableDocuments = (
  documents: Document[],
  allFilesNotProcessed: boolean,
  caseData?: Folder
): Document[] => {
  return documents.filter((doc) =>
    isDocumentSelectable(doc, allFilesNotProcessed, caseData)
  );
};

export const updateCaseInListProjects = (
  oldData: any,
  projectId: string,
  data: any
) => {
  return oldData.map((caseItem: any) =>
    caseItem.id === projectId ? { ...caseItem, ...data } : caseItem
  );
};

export const groupDocumentsByBatch = (documents: Document[]): Document[][] => {
  const batchGroups = new Map<string, Document[]>();

  documents.forEach((document) => {
    let batchKey: string;

    if (document.batchKey) {
      batchKey = document.batchKey;
    } else {
      // For legacy documents, group by authorId and hour
      const date = new Date(document.createdAt);
      const hourTimestamp = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours()
      ).getTime();

      batchKey = `legacy_${document.authorId}_${hourTimestamp}`;
    }

    if (!batchGroups.has(batchKey)) {
      batchGroups.set(batchKey, []);
    }
    batchGroups.get(batchKey)!.push(document);
  });

  return Array.from(batchGroups.values());
};

export const parseBatchKey = (
  batchKey: string
): { now: string; userId: string } => {
  const [, now, userId] = batchKey.split("_");
  return { now: formatBatchTimestamp(Number(now)), userId };
};

export const formatBatchTimestamp = (dateNumber: number): string => {
  return new Date(dateNumber).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
